import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'

import setup from '../../module/setup'
import LandingPage from './Scene/LandingPage'
import MyDashboard from './Scene/MyDashboard'
import Workout from './Scene/Workout'

import { AppWrapperOuter, AppWrapperInner } from './SceneManager-styled'

export default () => (
  <BrowserRouter>
    <AppWrapperOuter>
      <AppWrapperInner>
        <Route exact path="/" component={LandingPage} />
        <Route exact path={`/${setup.myDashboard.path}`} component={MyDashboard} />
        <Route exact path={`/${setup.workout.path}:questionBankId`} component={Workout} />
      </AppWrapperInner>
    </AppWrapperOuter>
  </BrowserRouter>
)



// WEBPACK FOOTER //
// ./src/component/_scenes/SceneManager.jsx